!(function () {
  var e = document.getElementById("elliSetBlock");
  var elliAdding = false;
  if (e) {
    var t = e.getAttribute("data-line") || "https://lin.ee/Sy1JIc6",
      CB = e.getAttribute("data-chat-badge") || "LINE",
      CV = e.getAttribute("data-convert-to") || "",
      rawDiscount = parseInt(e.getAttribute("data-discount"), 10),
      a = Number.isNaN(rawDiscount) ? 0 : Math.max(0, rawDiscount),
      n = (e.getAttribute("data-default-partner") || "").trim(),
      requirePartnerChoice = e.getAttribute("data-require-partner-choice") === "true",
      i = s("[data-set-pool]") || [],
      r = s("[data-set-a]"),
      I = s("[data-set-i18n]") || {};
    // Only accept a homepage pairing if it belongs to this product's allowed pool.
    var requestedPartner = new URLSearchParams(window.location.search).get("set_partner");
    if (requestedPartner && i.some(function(item){ return item.handle === requestedPartner; })) n = requestedPartner;
    if (r && i.length) {
      var l = {
          white: "#FDFCF8",
          cream: "#F4F1EA",
          "off-white": "#F0ECE3",
          ivory: "#F4EFE3",
          black: "#1A1A18",
          ink: "#1A1A18",
          natural: "#E8E0D0",
          sand: "#D4C8B0",
          beige: "#D9D0BF",
          linen: "#E0D8C8",
          ecru: "#EDE5D6",
          khaki: "#B5A98A",
          stone: "#B5A98A",
          sage: "#9BAF9E",
          olive: "#8E8A6C",
          green: "#7A9E8A",
          terracotta: "#A14E3F",
          rust: "#A14E3F",
          rose: "#C9A8A8",
          mauve: "#B8949C",
          blush: "#D4B0AA",
          pink: "#E0B7BC",
          navy: "#2C3E6B",
          blue: "#4A6E9E",
          turquoise: "#37BFC5",
          teal: "#4A7C7E",
          grey: "#9E9A95",
          gray: "#9E9A95",
          brown: "#7C5C40",
          yellow: "#E5C770",
          striped: "#D9D0BF",
          stripe: "#D9D0BF",
        },
        o = { a: { prod: null, sel: {} }, b: { prod: null, sel: {} } };
      (e.addEventListener("click", function (t) {
        var pairChoice = t.target.closest(".elli-set__pair-choice");
        if (pairChoice && e.contains(pairChoice) && pairChoice.closest(".elli-set__item")) {
          var pairSide = pairChoice.closest(".elli-set__item").getAttribute("data-side");
          if (!pairSide || !o[pairSide]) return;
          var pairState = o[pairSide],
            pairMap = P(pairState.prod);
          if (!pairMap) return;
          pairState.sel[pairState.prod.options[pairMap.color]] = pairChoice.getAttribute("data-color");
          pairState.sel[pairState.prod.options[pairMap.fabric]] = pairChoice.getAttribute("data-fabric");
          if (pairMap.size > -1) {
            var sizeName = pairState.prod.options[pairMap.size],
              sizeValue = pairState.sel[sizeName],
              sizeExists = pairState.prod.variants.some(function (variant) {
                return variant.options[pairMap.color] === pairState.sel[pairState.prod.options[pairMap.color]] &&
                  variant.options[pairMap.fabric] === pairState.sel[pairState.prod.options[pairMap.fabric]] &&
                  variant.options[pairMap.size] === sizeValue;
              });
            if (!sizeExists) {
              delete pairState.sel[sizeName];
              y(T("choose_size", "Choose a size"));
            } else y("");
          }
          return void h(pairSide);
        }
        var a = t.target.closest(".elli-set__swatch, .elli-set__pill");
        if (a && e.contains(a) && a.closest(".elli-set__item")) {
          var n = a.closest(".elli-set__item").getAttribute("data-side"),
            r = a.closest("[data-opt]");
          if (!n || !r) return;
          var l = r.getAttribute("data-opt");
          return (
            (o[n].sel[l] = a.getAttribute("data-val")),
            y(""),
            void h(n)
          );
        }
        if (t.target.closest("[data-set-change]"))
          !(function () {
            !(function () {
              var t = e.querySelector("[data-set-picker-grid]"),
                a = e.querySelector("[data-set-tabs]");
              if (t.childNodes.length) return;
              var n = i.slice().sort(function (e, t) {
                  return (t.available ? 1 : 0) - (e.available ? 1 : 0);
                }),
                r = [];
              i.forEach(function (e) {
                e.cat && r.indexOf(e.cat) < 0 && r.push(e.cat);
              });
              var l = v("button", "elli-set__tab is-active", T("all", "All"));
              ((l.type = "button"),
                l.setAttribute("data-tab", "*"),
                a.appendChild(l),
                r.length > 1 &&
                  r.forEach(function (e) {
                    var t = v("button", "elli-set__tab", e);
                    ((t.type = "button"),
                      t.setAttribute("data-tab", e),
                      a.appendChild(t));
                  }));
              n.forEach(function (e) {
                var a = v("button", "elli-set__pcard");
                ((a.type = "button"),
                  a.setAttribute("data-pick-handle", e.handle),
                  a.setAttribute("data-cat", e.cat || ""));
                var n = "";
                ((e.colors || []).slice(0, 5).forEach(function (e) {
                  n +=
                    '<span class="elli-set__pcard-dot" style="background:' +
                    d(e) +
                    '"></span>';
                }),
                  (a.innerHTML =
                    '<div class="elli-set__pcard-img">' +
                    (e.img
                      ? '<img src="' + e.img + '" alt="" loading="lazy">'
                      : "") +
                    (e.available
                      ? ""
                      : '<span class="elli-set__pcard-mto">' +
                        T("sold_out", "Sold out") +
                        "</span>") +
                    '</div><div class="elli-set__pcard-body"><span class="elli-set__pcard-name">' +
                    e.title +
                    '</span><span class="elli-set__pcard-price">' +
                    c(e.price) +
                    "</span>" +
                    (n
                      ? '<div class="elli-set__pcard-dots">' + n + "</div>"
                      : "") +
                    "</div>"),
                  t.appendChild(a));
              });
            })();
            var t = e.querySelector("[data-set-picker]");
            t &&
              ((t.hidden = !1),
              (document.documentElement.style.overflow = "hidden"));
          })();
        else if (t.target.closest("[data-set-picker-close]")) m();
        else {
          var s = t.target.closest("[data-pick-handle]");
          if (s) return (m(), void g(s.getAttribute("data-pick-handle")));
          var u,
            b = t.target.closest("[data-tab]");
          if (b)
            return (
              (u = b.getAttribute("data-tab")),
              e.querySelectorAll("[data-tab]").forEach(function (e) {
                e.classList.toggle(
                  "is-active",
                  e.getAttribute("data-tab") === u,
                );
              }),
              void e.querySelectorAll(".elli-set__pcard").forEach(function (e) {
                e.classList.toggle(
                  "is-hidden",
                  !("*" === u || e.getAttribute("data-cat") === u),
                );
              })
            );
          t.target.closest("[data-set-add]")
            ? A(!1)
            : t.target.closest("[data-set-buy]") && A(!0);
        }
      }),
        (o.a.prod = u(r)),
        _("a", r.sel),
        h("a"),
        n
          ? g(n)
          : requirePartnerChoice
            ? elliRenderPartnerChoice()
            : g((i.filter(function (e) { return e.available; })[0] || i[0]).handle),
        document.addEventListener("change", function(event) {
          if (!event.target.matches('form[id^="productForm-"] input[name="id"]')) return;
          var variant = o.a.prod.variants.find(function(item) { return String(item.id) === event.target.value; });
          if (variant) { _("a", variant.options); h("a"); }
        }),
        document.addEventListener("elli:currency-ready", function () {
          try {
            (h("a"), h("b"));
          } catch (e) {}
        }));
    } else e.style.display = "none";
  }
  function elliRoot() {
    return (e.getAttribute("data-root") || "/").replace(/\/?$/, "/");
  }
  function elliPath(path) {
    if (!path) return elliRoot();
    var root = elliRoot();
    if (path.indexOf(root) === 0 && root !== "/") return path;
    return root + path.replace(/^\//, "");
  }
  function elliMoney(cents) {
    var currency = e.getAttribute("data-currency") || "THB";
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency",
        currency: currency,
        currencyDisplay: "code",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(cents / 100);
    } catch (error) {
      return currency + " " + (cents / 100).toFixed(2);
    }
  }

  function s(t) {
    var a = e.querySelector(t);
    if (!a) return null;
    try {
      return JSON.parse(a.textContent);
    } catch (e) {
      return null;
    }
  }
  function T(e, t) {
    var a = I ? I[e] : null;
    return null != a && "" !== a ? a : t;
  }
  function d(e) {
    var t = (e || "").toLowerCase().trim();
    if (t.indexOf("polka") > -1)
      return "radial-gradient(circle,#1A1A18 0 1.5px,#FDFCF8 1.8px) 0 0/7px 7px";
    if (t.indexOf("stripe") > -1)
      return "repeating-linear-gradient(135deg,#FDFCF8 0 5px,#8CA5B7 5px 8px)";
    if (l[t]) return l[t];
    for (var a in l) if (t.indexOf(a) > -1) return l[a];
    return "#E2DBCE";
  }
  function c(e) {
    return elliMoney(e);
  }
  function FI(e) {
    return "string" == typeof e ? e : (e && e.src) || "";
  }
  function u(e) {
    var t = (e.options || []).map(function (e) {
        return "string" == typeof e ? e : (e && e.name) || "";
      }),
      a =
        e.img ||
        FI(e.featured_image) ||
        (e.images && e.images.length ? FI(e.images[0]) : "") ||
        "",
      n = (e.variants || []).map(function (e) {
        return {
          id: e.id,
          options: e.options || [],
          price: e.price,
          available: !!e.available,
          img: FI(e.featured_image) || e.img || a,
        };
      });
    return {
      handle: e.handle,
      title: e.title,
      url: e.url,
      options: t,
      variants: n,
      img: a,
    };
  }
  function p(e) {
    for (var t = 0; t < e.variants.length; t++)
      if (e.variants[t].available) return e.variants[t];
    return e.variants[0] || null;
  }
  function f(e, t) {
    return (
      e.variants.filter(function (a) {
        return e.options.every(function (e, n) {
          return !t[e] || a.options[n] === t[e];
        });
      })[0] || null
    );
  }
  function x(e, t) {
    if (!e || !e.options.every(function (name) { return t[name] != null && t[name] !== ""; })) return null;
    return e.variants.filter(function (variant) {
      return e.options.every(function (name, index) {
        return variant.options[index] === t[name];
      });
    })[0] || null;
  }
  function O(name) {
    return (name || "").toLowerCase().trim();
  }
  function P(product) {
    if (!product) return null;
    var color = -1, fabric = -1, size = -1;
    product.options.forEach(function (name, index) {
      var key = O(name);
      if (["color", "colour", "สี", "颜色", "顏色", "カラー", "색상"].indexOf(key) > -1) color = index;
      if (["fabric", "material", "เนื้อผ้า", "ผ้า", "面料", "材质", "材質", "素材", "원단", "소재"].indexOf(key) > -1) fabric = index;
      if (["size", "ขนาด", "尺码", "尺碼", "サイズ", "사이즈"].indexOf(key) > -1) size = index;
    });
    if (color < 0 || fabric < 0) return null;
    var fabrics = [];
    product.variants.forEach(function (variant) {
      var value = variant.options[fabric];
      if (value && fabrics.indexOf(value) < 0) fabrics.push(value);
    });
    return fabrics.length > 1 ? { color: color, fabric: fabric, size: size, fabrics: fabrics } : null;
  }
  function v(e, t, a) {
    var n = document.createElement(e);
    return (t && (n.className = t), null != a && (n.innerHTML = a), n);
  }
  function h(n) {
    var i = e.querySelector('.elli-set__item[data-side="' + n + '"]'),
      r = o[n],
      l = r.prod;
    if (i && l) {
      i.innerHTML = "";
      var selectedVariant = x(l, r.sel),
        s = selectedVariant || f(l, r.sel) || p(l),
        u = !!selectedVariant && !selectedVariant.available,
        h = (s && s.img) || l.img,
        _ = v("div", "elli-set__img-wrap"),
        g = v("a");
      g.href =
        elliPath(l.url) +
        (l.url.indexOf("?") > -1 ? "&" : "?") +
        "variant=" +
        s.id;
      var m = document.createElement("img");
      ((m.src = h),
        (m.alt = l.title),
        (m.loading = "lazy"),
        g.appendChild(m),
        _.appendChild(g));
      var C = v(
        "span",
        "elli-set__mto-tag",
        T("sold_out", "Sold out"),
      );
      ((C.hidden = !u), _.appendChild(C), i.appendChild(_));
      var y = v("div", "elli-set__nm"),
        A = v("p", "elli-set__name"),
        E = v("a");
      if (
        ((E.href =
          elliPath(l.url) +
          (l.url.indexOf("?") > -1 ? "&" : "?") +
          "variant=" +
          s.id),
        (E.textContent = l.title),
        A.appendChild(E),
        y.appendChild(A),
        "b" === n)
      ) {
        var w = v("button", "elli-set__change", T("change", "Change"));
        ((w.type = "button"),
          w.setAttribute("data-set-change", ""),
          y.appendChild(w));
      }
      i.appendChild(y);
      var pairMap = P(l);
      if (pairMap) {
        i.appendChild(v("span", "elli-set__opt-label elli-set__pair-heading", T("colour_fabric", "Colour & fabric")));
        var pairPicker = v("div", "elli-set__pair-picker");
        pairMap.fabrics.forEach(function (fabricValue) {
          var pairRow = v("div", "elli-set__pair-row"),
            fabricLabel = v("span", "elli-set__pair-fabric"),
            pairChoices = v("div", "elli-set__pair-choices"),
            colors = [];
          var selectedFabric = r.sel[l.options[pairMap.fabric]],
            selectedColor = r.sel[l.options[pairMap.color]];
          fabricLabel.textContent = fabricValue + (selectedFabric === fabricValue && selectedColor ? " · " + selectedColor : "");
          l.variants.forEach(function (variant) {
            if (variant.options[pairMap.fabric] !== fabricValue) return;
            var colorValue = variant.options[pairMap.color];
            if (colorValue && colors.indexOf(colorValue) < 0) colors.push(colorValue);
          });
          colors.forEach(function (colorValue) {
            var pairAvailable = l.variants.some(function (variant) {
                return variant.options[pairMap.color] === colorValue &&
                  variant.options[pairMap.fabric] === fabricValue &&
                  variant.available;
              }),
              active = r.sel[l.options[pairMap.color]] === colorValue &&
                r.sel[l.options[pairMap.fabric]] === fabricValue,
              pairButton = v(
                "button",
                "elli-set__pair-choice" + (active ? " is-active" : "") + (pairAvailable ? "" : " is-soldout"),
              ),
              dot = v("span", "elli-set__pair-dot"),
              text = v("span", "elli-set__pair-name");
            pairButton.type = "button";
            pairButton.setAttribute("data-color", colorValue);
            pairButton.setAttribute("data-fabric", fabricValue);
            pairButton.setAttribute("aria-label", colorValue + " · " + fabricValue + (pairAvailable ? "" : " · " + T("sold_out", "Sold out")));
            pairButton.setAttribute("aria-pressed", active ? "true" : "false");
            pairButton.title = colorValue + " · " + fabricValue;
            dot.style.background = d(colorValue);
            text.textContent = colorValue;
            pairButton.appendChild(dot);
            pairButton.appendChild(text);
            pairChoices.appendChild(pairButton);
          });
          pairRow.appendChild(fabricLabel);
          pairRow.appendChild(pairChoices);
          pairPicker.appendChild(pairRow);
        });
        i.appendChild(pairPicker);
      }
      (l.options.forEach(function (e, t) {
          var a,
            n = O(e),
            o = [];
          if (pairMap && (t === pairMap.color || t === pairMap.fabric)) return;
          if (
            (l.variants.forEach(function (e) {
              var a = e.options[t];
              a && o.indexOf(a) < 0 && o.push(a);
            }),
            "title" === n && 1 === l.options.length)
          )
            return (
              i.appendChild(
                v("span", "elli-set__opt-label", T("size", "Size")),
              ),
              void i.appendChild(
                v("span", "elli-set__free", T("free_size", "Free size")),
              )
            );
          if (["colour", "color", "สี", "颜色", "顏色", "カラー", "색상"].indexOf(n) > -1) {
            i.appendChild(v("span", "elli-set__opt-label", T("color", "Colour")));
            var s = v("div", "elli-set__swatches");
            (s.setAttribute("data-opt", e),
              o.forEach(function (t) {
                var a = v(
                  "button",
                  "elli-set__swatch" + (r.sel[e] === t ? " is-active" : ""),
                );
                ((a.type = "button"),
                  (a.title = t),
                  a.setAttribute("aria-label", t),
                  a.setAttribute("data-val", t));
                var n = document.createElement("span");
                ((n.style.background = d(t)),
                  a.appendChild(n),
                  s.appendChild(a));
              }),
              i.appendChild(s));
          } else if (["size", "ขนาด", "尺码", "尺碼", "サイズ", "사이즈"].indexOf(n) > -1) {
            if (
              (i.appendChild(
                v("span", "elli-set__opt-label", T("size", "Size")),
              ),
              o.length <= 1)
            )
              return void i.appendChild(
                v("span", "elli-set__free", T("free_size", "Free size")),
              );
            var c = v("div", "elli-set__pills");
            (c.setAttribute("data-opt", e),
              o.forEach(function (a) {
                var sizeVariants = l.variants.filter(function (variant) {
                    if (variant.options[t] !== a) return false;
                    if (!pairMap) return true;
                    return variant.options[pairMap.color] === r.sel[l.options[pairMap.color]] &&
                      variant.options[pairMap.fabric] === r.sel[l.options[pairMap.fabric]];
                  }),
                  sizeExists = sizeVariants.length > 0,
                  n = sizeVariants.some(function (variant) { return variant.available; }),
                  i = v(
                    "button",
                    "elli-set__pill" +
                      (r.sel[e] === a ? " is-active" : "") +
                      (n ? "" : " is-soldout"),
                  );
                if (!sizeExists) return;
                ((i.type = "button"),
                  i.setAttribute("data-val", a),
                  (i.textContent = a),
                  c.appendChild(i));
              }),
              i.appendChild(c));
          } else {
            if (o.length <= 1) return;
            i.appendChild(v("span", "elli-set__opt-label", e));
            var u = v("div", "elli-set__pills");
            (u.setAttribute("data-opt", e),
              o.forEach(function (t) {
                var a = v(
                  "button",
                  "elli-set__pill" + (r.sel[e] === t ? " is-active" : ""),
                );
                ((a.type = "button"),
                  a.setAttribute("data-val", t),
                  (a.textContent = t),
                  u.appendChild(a));
              }),
              i.appendChild(u));
          }
        }),
        (function () {
          var t = b("a"),
            n = b("b"),
            i = t ? t.price : 0,
            r = n ? n.price : 0,
            l = t && n ? i + r : 0,
            o = Math.round((l * (100 - a)) / 100),
            s = l - o,
            d = e.querySelector("[data-set-disc]"),
            u = e.querySelector("[data-set-orig]"),
            p = e.querySelector("[data-set-save]");
          d && (d.textContent = l ? c(o) : "—");
          u && ((u.textContent = l && a > 0 ? c(l) : ""), (u.hidden = !(l && a > 0)));
          p &&
            (l && s > 0
              ? ((p.textContent = T("save", "Save {amount}").replace(
                  "{amount}",
                  c(s),
                )),
                (p.hidden = !1))
              : (p.hidden = !0));
        })());
    }
    elliSyncButtons();
  }
  function elliSyncButtons() {
    var selectedA = b("a"),
      selectedB = b("b"),
      disabled = elliAdding || !selectedA || !selectedB || !selectedA.available || !selectedB.available;
    e.querySelectorAll("[data-set-add], [data-set-buy]").forEach(function(button) { button.disabled = !!disabled; });
  }
  function b(e) {
    var t = o[e];
    return t.prod ? x(t.prod, t.sel) : null;
  }
  function elliRenderPartnerChoice() {
    o.b.prod = null;
    var item = e.querySelector('.elli-set__item[data-side="b"]');
    if (!item) return;
    item.innerHTML = "";
    var choose = v("button", "elli-set__choose-card");
    choose.type = "button";
    choose.setAttribute("data-set-change", "");
    choose.innerHTML = '<span class="elli-set__choose-plus" aria-hidden="true">+</span><span>' + T("choose_piece", "Choose a second piece") + "</span>";
    item.appendChild(choose);
    elliSyncButtons();
  }
  function _(e, t) {
    var a = o[e];
    a.sel = {};
    var n = null;
    (t &&
      t.length &&
      (n = a.prod.variants.filter(function (e) {
        return a.prod.options.every(function (a, n) {
          return e.options[n] === t[n];
        });
      })[0]),
      n || (n = p(a.prod)),
      n &&
        a.prod.options.forEach(function (e, t) {
          a.sel[e] = n.options[t];
        }));
  }
  function g(t) {
    o.b.prod = null;
    h("a");
    var a = e.querySelector('.elli-set__item[data-side="b"]');
    (a &&
      !a.querySelector(".elli-set__img-wrap") &&
      (a.innerHTML = '<div class="elli-set__skel" aria-hidden="true"></div>'),
      fetch(elliPath("/products/" + encodeURIComponent(t) + ".js"))
        .then(function (e) {
          if (!e.ok) throw 0;
          return e.json();
        })
        .then(function (e) {
          ((o.b.prod = u(e)), _("b"), h("b"));
        })
        .catch(function () {
          var e =
            i.filter(function (e) {
              return e.available;
            })[0] || i[0];
          e && e.handle !== t && g(e.handle);
        }));
  }
  function m() {
    var t = e.querySelector("[data-set-picker]");
    t && ((t.hidden = !0), (document.documentElement.style.overflow = ""));
  }
  function C() {
    var n = function () {
      var t = document.querySelector(".js-header-cart-status-btn");
      if (t) {
        t.click();
        return !0;
      }
      var a = document.getElementById("shtCartDrawer");
      return (
        !!a &&
        (a.setAttribute("aria-hidden", "false"),
        a.classList.add("active", "is-open"),
        document.documentElement.classList.add("sht-drawer-open"),
        !0)
      );
    };
    try {
      if (
        window.SHTHelper &&
        "function" == typeof window.SHTHelper.forceUpdateCartStatus
      ) {
        var t = window.SHTHelper.forceUpdateCartStatus();
        if (t && "function" == typeof t.then) return (t.then(n).catch(n), !0);
        setTimeout(n, 120);
        return !0;
      }
    } catch (e) {}
    return n();
  }
  function y(t) {
    var a = e.querySelector("[data-set-note]");
    a && ((a.textContent = t), (a.hidden = !t));
  }
  function A(a) {
    if (elliAdding || !b("a") || !b("b")) return;
    var n = b("a"),
      i = b("b"),
      r = [];
    if (!n.available || !i.available) return void y(T("sold_out", "Sold out"));
    r.push({ id: n.id, quantity: 1 }, { id: i.id, quantity: 1 });
    var o = e.querySelector("[data-set-add]"),
      s = e.querySelector("[data-set-buy]"),
      d = a ? s : o,
      c = d ? d.innerHTML : "";
    function u() {
      elliAdding = false;
      d && ((d.disabled = !1), (d.innerHTML = c));
      elliSyncButtons();
    }
    elliAdding = true;
    elliSyncButtons();
    (d && ((d.disabled = !0), (d.textContent = T("adding", "Adding…"))),
      fetch(elliPath("/cart/add.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: r }),
      })
        .then(function (e) {
          if (!e.ok) throw new Error("add");
          return e.json();
        })
        .then(function () {
          (y(""),
            a
              ? (window.location.href = elliPath("/checkout"))
              : (d &&
                  ((d.innerHTML = T("added", "Added ✓")), setTimeout(u, 2500)),
                C() || (window.location.href = elliPath("/cart"))));
        })
        .catch(function () {
          (u(),
            y(
              T(
                "add_error",
                "We couldn’t add the set just now — it may already be in your cart, or a piece is low in stock. Opening your cart…",
              ),
            ),
            C());
        }));
  }
})();
